import Select from "react-select";
import styled from "styled-components";
import { useHistory } from "react-router";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { RootState } from "../../store/rootReducer";
import { useDispatch, useSelector } from "react-redux";
import { getSelectedStatusOption, STATUS_OPTIONS, Option, allowSave, allowDelete } from "../../store/helpers";
import { createJenisLembagaAsync, getDetailJenisLembagaAsync, initializeCreateJenisLembaga, updateJenisLembagaAsync, updateName, updateStatus } from "../../reducers/jenisLembaga/jenisLembaga.actions";
import { fieldErrorMessage, fieldHasErrors } from "../../store/errorHandler";
import { PermissionMenuName } from "../../interfaces/UserRole";

export const JenisLembagaUpdatePage = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const [isNew, setIsNew] = useState<boolean>(false);
  const errors = useSelector((state: RootState) => state.jenisLembaga.error);
  const isLoading = useSelector((state: RootState) => state.jenisLembaga.isLoading);
  const redirectQueue = useSelector((state: RootState) => state.jenisLembaga.redirectQueue);
  const jenisLembaga = useSelector((state: RootState) => state.jenisLembaga.selectedJenisLembaga);
  const role = useSelector((state: RootState) => state.authorization.systemAccess[PermissionMenuName.masterData].ACCESS);

  const canSave = allowSave(role, 2);
  
  useEffect(() => {
    const paths = location.pathname.split("/");
    if (paths[2] === 'create') {
      setIsNew(true);
      dispatch(initializeCreateJenisLembaga());
    } else {
      setIsNew(false);
      const id = parseInt(paths[2]);
      if (id && !isNaN(id)) {
        dispatch(getDetailJenisLembagaAsync.request({ id }));
      } else {
        history.push(`/jenis-lembaga/create`);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  useEffect(() => {
    if (redirectQueue) {
      history.push(redirectQueue);
      dispatch(initializeCreateJenisLembaga());
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [redirectQueue])

  const onChangeName = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateName(e.target.value));
  }

  const onChangeStatus = (e: Option | null) => {
    if (!e) return;
    if (isNaN(parseInt(e.value))) return;
    dispatch(updateStatus(parseInt(e.value)));
  }

  const save = () => {
    if (!jenisLembaga) return;
    if (isNew) {
      dispatch(createJenisLembagaAsync.request(jenisLembaga))
    } else {
      dispatch(updateJenisLembagaAsync.request(jenisLembaga))
    }
  }
 
  return (
    <JenisLembagaUpdatePageWrapper>
      <section className="content">
        <div className="row">
          <div className="col-lg-5">
            <div className="box">
              <div className="box-header with-border">
                <h3 className="box-title">Detail Jenis Lembaga</h3>
                <div className="box-tools">
                  <button
                    className="btn btn-primary"
                    style={{marginRight: '4px'}}
                    onClick={() => history.push('/jenis-lembaga')}
                  >
                    kembali
                  </button>
                  <button
                    className="btn btn-primary"
                    disabled={isLoading || !canSave}
                    onClick={save}
                  >
                    Simpan
                  </button>
                </div>
              </div>
              <div className="box-body">
                <div className={`form-group ${fieldHasErrors('CO_TYP_NAME', errors) ? 'has-error' : ''}`}>
                  <label>Nama Jenis Lembaga <span className="text-red"><b>*</b></span></label>
                  <input
                    type="text"
                    onChange={onChangeName}
                    className='form-control'
                    disabled={isLoading || !canSave}
                    defaultValue={jenisLembaga?.CO_TYP_NAME}
                    style={{ display: 'block', width: '100%' }}
                  />
                  <span className="help-block">{ fieldErrorMessage('CO_TYP_NAME', errors) }</span>
                </div>
                <div className="form-group">
                  <label>Status <span className="text-red"><b>*</b></span></label>
                  <Select 
                    options={STATUS_OPTIONS}
                    onChange={onChangeStatus}
                    value={getSelectedStatusOption(jenisLembaga?.STATUS)}
                    isDisabled={isLoading || !allowDelete(role, 2)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </JenisLembagaUpdatePageWrapper>
  );
}

const JenisLembagaUpdatePageWrapper = styled.div``;